
 
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute from '../Components/PrivateRoute'
import AddressPage from '../Pages/AddressPage'
import Admin from '../Pages/Admin'
 
import CartPage from '../Pages/CartPage'
 
import Home from '../Pages/Home'
import Kids from '../Pages/Kids'
import Login from '../Pages/Login'
import Men from '../Pages/Men'
import NotFound from '../Pages/NotFound'
import PaymentPage from '../Pages/PaymentPage'
import SignUp from '../Pages/SignUp'
import Women from '../Pages/Women'
import MenWearDetails from '../Pages/MenWearDetails'
import WomenWearDetails from '../Pages/WomenWearDetails'
import KidsWearDetails from '../Pages/KidsWearDetails'
import Thankyou from '../Pages/Thankyou'
 
const AllRoutes = () => {
  return (
    <div>     
        <Routes>
            <Route path="/" element={<Home/>}></Route>
            <Route path="/thanks" element={<Thankyou/>}></Route>
            <Route path="/login" element={<Login/>}></Route>
            <Route path="/register" element={<SignUp/>}></Route>
            <Route path="/men" element={<Men/>}></Route>
            <Route path="/women" element={<Women/>}></Route>
            <Route path="/kids" element={<Kids/>}></Route>
            <Route path="/men/:id" element={<MenWearDetails/>}></Route>
            <Route path="/women/:id" element={<WomenWearDetails/>}></Route>
            <Route path="/kids/:id" element={<KidsWearDetails/>}></Route>
            
            <Route path="*" element={<NotFound/>}></Route>
            
            <Route path="/cart" element={  
               <PrivateRoute>    
                      <CartPage/>  
                </PrivateRoute>  
            }></Route>
            <Route path="/address" element={   
              <PrivateRoute>
                      <AddressPage/>  
              </PrivateRoute>    
            }></Route>
            <Route path="/payment" element={    
                <PrivateRoute>
                      <PaymentPage/>  
                </PrivateRoute>   
            }></Route>
            <Route path="/admin" element={  
                <PrivateRoute>
                      <Admin/>  
                </PrivateRoute>     
            }></Route>

        </Routes>
    </div>
  )
}

export default AllRoutes